import { render, staticRenderFns } from "./VideoBanner.vue?vue&type=template&id=6857d65c&scoped=true&"
import script from "./VideoBanner.vue?vue&type=script&lang=ts&"
export * from "./VideoBanner.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBanner.vue?vue&type=style&index=0&id=6857d65c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6857d65c",
  null
  
)

export default component.exports